"use client";

// Available funds offer card — Figma 8301:73126.

import { ProductWidgetFrame, ScaledProductWidgetCanvas } from "./mock-frame";

export function AvailableFundsWidget({ className }: { className?: string }) {
  return (
    <ProductWidgetFrame className={className}>
      <ScaledProductWidgetCanvas>
        <div
          className="absolute top-1/2 left-1/2 h-[200px] w-[292px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[16.909px] bg-[#f1f0f0]"
          style={{ marginLeft: 0.17 }}
        >
          <div className="absolute inset-x-0 top-0 h-[143px] rounded-[16.909px] border-[0.705px] border-[#e6e6e5] bg-white shadow-[0px_2.818px_0.352px_rgba(0,0,0,0.04)]">
            <p className="absolute top-[39.82px] left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-[12.682px] leading-[1.2] font-medium whitespace-nowrap text-[#0d0d0d]">
              Available funds
            </p>

            <div className="absolute top-[56.27px] left-1/2 flex -translate-x-1/2 items-center gap-[5.186px] text-[43.845px] leading-[1.2] font-medium tracking-[-0.609px] whitespace-nowrap">
              <span className="shrink-0 text-[#707070]">$</span>
              <span className="shrink-0 text-[#161517]">1,240,000</span>
            </div>
          </div>

          <div className="absolute inset-x-0 top-[143px] flex h-[57px] flex-col items-center justify-center px-[16.909px] pt-[11.273px] pb-[16.909px]">
            <p className="w-[191.639px] text-center text-[9.864px] leading-[1.4] text-[#161517]">
              $1,240,000 arriving to your account ****1234 in 1 to 2 business
              days.
            </p>
          </div>
        </div>
      </ScaledProductWidgetCanvas>
    </ProductWidgetFrame>
  );
}
